import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [{ id: "056c84a5-fc60-4d37-8a87-0999d7d950f5", content: "DIN 45681", options: {} }];

const groups = [
  {
    id: "2ea13003-3754-4b97-ae83-7ff5ca2ff701",
    content: "does not operate with psychoacoustic parameters",
    options: {},
  },
  { id: "6f085bf8-e133-457c-88d9-187f61d76fcf", content: "ignores cavum cochae resonance of the ear", options: {} },
  { id: "c2849538-883f-44fd-b212-79e7af731686", content: "incompletely implemented", options: {} },
  { id: "1e5f7521-918a-4677-aa99-2ba636c168ec", content: "does not give spectral information", options: {} },
  { id: "c7904c9d-b546-4694-b41e-d7a0dee78112", content: "can only be used for pure tone analysis", options: {} },
  { id: "71aa4df7-e094-4e14-910f-cf571b7bcd75", content: "require high frequency resolution", options: {} },
];

export const task: Task = {
  id: "5b07a427-aee7-426d-88d7-e4b43fc943b8",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "2ea13003-3754-4b97-ae83-7ff5ca2ff701", itemsId: ["056c84a5-fc60-4d37-8a87-0999d7d950f5"] },
    { groupId: "6f085bf8-e133-457c-88d9-187f61d76fcf", itemsId: ["056c84a5-fc60-4d37-8a87-0999d7d950f5"] },
    { groupId: "c7904c9d-b546-4694-b41e-d7a0dee78112", itemsId: ["056c84a5-fc60-4d37-8a87-0999d7d950f5"] },
    { groupId: "71aa4df7-e094-4e14-910f-cf571b7bcd75", itemsId: ["056c84a5-fc60-4d37-8a87-0999d7d950f5"] },
  ],
};
